import React from "react";
import { Card } from "antd";
import { CSSProperties, ReactNode } from "react";

type Props = {
  children: ReactNode;
  visible?: boolean;
  style?: CSSProperties;
};

const AssistivePopUp = ({ children, visible, style }: Props) => {
  if (!visible) return null;
  return (
    <Card
      style={{
        boxShadow: "0px 2px 8px rgba(40, 41, 61, 0.04), 0px 16px 24px rgba(96, 97, 112, 0.16)",
        borderRadius: "8px",
        padding: 14,
        position: "absolute",
        left: "100%",
        top: "-60px",
        width: "288px",
        ...style,
      }}
      bodyStyle={{ padding: 0 }}
    >
      {children}
    </Card>
  );
};

export default AssistivePopUp;
